import * as PickstarUserAnalytics from '@pickstar/user-analytics'

export default {
  methods: {
    trackEvent (MenuItem) {
      if (this.$analytics) {
        this.$analytics.track(new PickstarUserAnalytics.V2.NavigationDashboardSideMenuClickEvent(MenuItem))
      }
    },
    getNavigationSideMenuItem (view) {
      switch (view) {
        case 'vetting.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.REQUESTS_PENDING
        case 'requests.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.REQUESTS_PRIVATE
        case 'billboard.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.REQUESTS_PUBLIC
        case 'bookings.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.BOOKINGS
        case 'payments.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.PAYMENTS
        case 'threads.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.CHATS
        case 'system.notifications.create':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.NOTIFICATIONS_SEND
        case 'system.notifications':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.NOTIFICATIONS_SENT
        case 'calendar.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.DASHBOARDS_CALENDAR
        case 'bidashboards.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.DASHBOARDS_ANALYTICS
        case 'system.reports':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.REPORTS
        case 'system.tags':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.TAGS
        case 'system.tags.tree':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.TAGS_TREE
        case 'system.tags.node':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.TAGS_MANAGE
        case 'logout':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.LOGOUT
        case 'clients.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS_CLIENTS
        case 'talent.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS_STARS
        case 'managers.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS_MANAGERS
        case 'system.admin-management':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS_ADMINS
        case 'system.intern-management':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS_INTERNS
        case 'campaigns.index':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.CAMPAIGNS
        case 'booking-importer':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.IMPORT_BOOKINGS
        case 'importer':
          return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.IMPORT_USERS
        default:
          return null
      }
    },
    getNavigationSideMenuHeaderItem (headerLink) {
      if (!headerLink.items || headerLink.items.length === 0) {
        return null
      }
      for (const item of headerLink.items) {
        switch (item.view) {
          case 'vetting.index':
          case 'requests.index':
          case 'billboard.index':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.REQUESTS
          case 'system.notifications.create':
          case 'system.notifications':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.NOTIFICATIONS
          case 'calendar.index':
          case 'bidashboards.index':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.DASHBOARDS
          case 'system.tags':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.TAGS
          case 'clients.index':
          case 'talent.index':
          case 'managers.index':
          case 'system.admin-management':
          case 'system.intern-management':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.USERS
          case 'importer':
          case 'booking-importer':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.IMPORT
          case 'campaigns.index':
            return PickstarUserAnalytics.V2.NavigationDashboardSideMenuItem.CAMPAIGNS
        }
      }

      return null
    }
  }
}
